const initContentAccordion = () => {
	const wrappers = document.querySelectorAll('[data-content-accordion]');
	if (!wrappers.length) return;

	wrappers.forEach((wrapper) => {
		const triggers = wrapper.querySelectorAll('[data-accordion-trigger]');

		triggers.forEach((trigger) => {
			const panel = trigger.nextElementSibling;
			const entry = trigger.closest('.accordion-entry');
			if (!panel) return;

			if (trigger.getAttribute('aria-expanded') === 'true') {
				panel.style.maxHeight = panel.scrollHeight + 'px';
				entry.classList.add('is-open');
			}

			trigger.addEventListener('click', () => handleClick(wrapper, trigger));
		});
	});
};

const handleClick = (wrapper, trigger) => {
	const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
	const panel = trigger.nextElementSibling;
	const entry = trigger.closest('.accordion-entry');

	wrapper.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
		if (trigger === trigger) return;
		const panel = trigger.nextElementSibling;
		trigger.setAttribute('aria-expanded', 'false');
		trigger.querySelector('[data-accordion-icon]').textContent = '+';
		if (entry) entry.classList.remove('is-open');
		if (panel) panel.style.maxHeight = '0px';
	});

	if (!isExpanded && panel) {
		trigger.setAttribute('aria-expanded', 'true');
		trigger.querySelector('[data-accordion-icon]').textContent = '−';
		panel.style.maxHeight = panel.scrollHeight + 'px';
		if (entry) entry.classList.add('is-open');
	} else if (panel) {
		trigger.setAttribute('aria-expanded', 'false');
		trigger.querySelector('[data-accordion-icon]').textContent = '+';
		panel.style.maxHeight = '0px';
		if (entry) entry.classList.remove('is-open');
	}
};

export { initContentAccordion };
